<template>
  <section class="BorderedBox" :class="className">
    <slot></slot>
  </section>
</template>

<script>
import cx from "classnames";
export default {
  name: "BorderedBox",
  props: {
    green: Boolean,
    dashed: Boolean
  },
  computed: {
    className() {
      return cx({
        green: this.green,
        dashed: this.dashed
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.BorderedBox {
  padding: 27px 36px;

  border: 4px solid $c-green;

  & + .BorderedBox {
    margin-top: $spacing8;
  }

  &.green {
    color: $c-green;
  }

  &.dashed {
    border-style: dashed;
  }
}
</style>
